<template>
  <div class="car-choose-container">
    <ucar-title type="model" @close="close">车型</ucar-title>
    <div class="car-brand" ref="brand" v-scroll:brand="currentIndex" v-if="loaded">
      <div>
        <template v-for="(item, index) in brandList">
          <div class="car-brand-header" :data-id="item.indent" :key="item.indent + index + 'd'">{{item.indent}}</div>
          <ul class="car-brand-wrapper" :key="item.indent + index">
            <li
              v-for="brand in item.children"
              :key="brand.carIdent"
              @click="chooseBrand(brand)"
              :class="{ 'selected' : currentBrand.carIdent === brand.carIdent}"
            >{{brand.carIdent}}</li>
          </ul>
        </template>
      </div>
    </div>
    <div class="car-choose-index">
      <span class="car-choose-span" v-for="item in brandIndex" :key="item" @click="chooseIndex(item)">{{item}}</span>
    </div>
    <div
      class="car-model"
      :class="{'model-stage' : status === 1, 'color-stage' : status === 2}"
      ref="model"
      v-scroll:model
    >
      <div>
        <div class="car-model-header">{{currentBrand.carIdent}}</div>
        <ul class="car-model-wrapper">
          <li
            v-for="(item, index) in modelList"
            :key="item.carName + index"
            @click="chooseModel(item, $event)"
            :class="{'selected' : currentModel.id === item.id}"
            :data-id="item.carName"
          >{{item.carName}}</li>
        </ul>
      </div>
    </div>
    <div class="car-color" :class="{'color-stage-car-color' : status === 2}" v-scroll:color>
      <ul class="car-color-wrapper">
        <li
          v-for="item in colorList"
          :key="item.id"
          @click="chooseColor(item)"
          :class="{'selected' : currentColor.id === item.id}"
        >
          <span class="color-item-mark" :style="{ backgroundColor : item.color}"></span>

          {{item.name}}
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.car-choose-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: 999;
}

.car-brand,
.car-model,
.car-color {
  touch-action: none;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
  box-sizing: border-box;
}

.car-model,
.car-color {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  transform: translateX(100%);
  transition: transform 0.3s;
  border-left: 1px solid #e9e9e9; /*no*/
}

.model-stage {
  transform: translateX(45%);
}

.color-stage {
  transform: translateX(30%);
}

.color-stage-car-color {
  transform: translateX(70%);
}

.car-model {
  z-index: 2;
  margin-top: 88px;
}

.car-color {
  z-index: 3;
  margin-top: 88px;
}

.car-brand-header,
.car-model-header {
  text-align: left;
  background-color: #e9e9e9;
  height: 60px;
  line-height: 60px;
  font-size: 32px;
  padding: 0 30px;
}

.car-brand ul,
.car-model ul,
.car-color ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.car-choose-container li {
  display: flex;
  padding: 26px 30px;
  border-bottom: 1px solid #e9e9e9; /*no*/
  font-size: 28px;
  align-items: center;
  box-sizing: border-box;
  line-height: 1.5;
}

.car-choose-container li.selected {
  background-color: #fffaf0;
}

.color-item-mark {
  display: inline-block;
  border-radius: 50%;
  border: 1px solid #e9e9e9; /*no*/
  width: 32px;
  height: 32px;
  margin-right: 20px;
}

.selected {
  background-color: #fffaf0;
}

.car-choose-index {
  position: absolute;
  display: flex;
  flex-flow: nowrap column;
  align-items: center;
  justify-content: center;
  right: 0;
  top: 50%;
  width: 40px;
  min-height: 0;
  transform: translate3d(0, -50%, 0);
  z-index: 10;
}

.car-choose-span {
  font-size: 28px;
  color: #333;
  line-height: 36px;
  min-height: 0;
  width: 40px;
  height: 36px;
  text-align: center;
}

.hidden {
  display: none;
}
</style>

<script>
import Iscroll from 'iscroll'
import { colors } from '../utils/constants'
import { getVehicleDict } from '../api'

export default {
  data () {
    return {
      showModel: false,
      showColor: false,
      color: null,
      currentBrand: {},
      brandList: [],
      originBrandList: [],
      currentModel: {},
      modelList: [],
      currentColor: {},
      colorList: colors,
      loaded: false,
      brandIndex: [],
      currentIndex: ''
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  directives: {
    scroll: {
      inserted (el, binding, vnode) {
        vnode.scroll = new Iscroll(el, {
          click: true
        })
        let moveDistance = 30
        let startX = 0
        let endX = 0
        const vm = vnode.context
        vnode.scroll.on('scrollStart', function () {
          let directionY = this.directionY
          if (directionY !== 0) {
            switch (binding.arg) {
              case 'brand':
                vm.hiddenModel()
                vm.hiddenColor()
                break
              case 'model':
                vm.hiddenColor()
                break
              default:
                break
            }
          }
        })
        vnode.scroll.on('scrollEnd', function () {
          endX = this.pointX
          if (endX - startX > moveDistance) {
            switch (binding.arg) {
              case 'brand':
                vm.hiddenModel()
                vm.hiddenColor()
                break
              case 'model':
                vm.hiddenColor()
                break
              default:
                break
            }
          }
        })
      },
      componentUpdated (el, binding, vnode, oldVnode) {
        vnode.scroll = oldVnode.scroll
        vnode.scroll.refresh()
        if (binding.value && binding.value !== vnode.scroll.scrollPosition) {
          vnode.scroll.scrollToElement(`[data-id="${binding.value}"]`, 300)
          vnode.scroll.scrollPosition = binding.value
        }
      },
      unbind (el, binding, vnode, oldVnode) {
        vnode.scroll = oldVnode.scroll
        vnode.scroll.destroy()
        vnode.scroll = null
      }
    }
  },
  computed: {
    status () {
      if (this.showModel) {
        return this.showModel && this.showColor ? 2 : 1
      }
      return 0
    }
  },
  methods: {
    init () {
      this.$loading.show()
      // 新接口
      getVehicleDict()
        .then(re => {
          const arr = []
          this.originBrandList = re
          re.reduce((pre, current) => {
            if (
              pre &&
              current &&
              current.carIdentInitials === pre.carIdentInitials
            ) {
              arr[arr.length - 1]['children'].push(current)
            } else {
              arr.push({
                indent: current.carIdentInitials,
                children: [current]
              })
              this.brandIndex.push(current.carIdentInitials)
            }
            return current
          }, null)
          return Promise.resolve(arr)
        })
        .then(arr => {
          this.brandList = arr
          if (this.value && this.value.currentModel) {
            this.currentBrand = this.originBrandList.filter(item => {
              return this.value.currentBrand.carIdent === item.carIdent
            })[0]
            this.modelList = this.currentBrand.vehicleModeList
            this.currentModel = this.value.currentModel
            this.currentColor = this.value.currentColor
            this.showModel = true
            this.showColor = true
          }
          this.$loading.hidden()
          this.loaded = true
        })
        .catch(({ data }) => {
          this.$loading.hidden()
          this.$alert(data.msg)
        })
    },
    close () {
      this.$emit('change')
    },
    chooseBrand (item) {
      this.hiddenColor()
      this.modelList = item.vehicleModeList
      this.currentBrand = item
      this.showModel = true
    },
    chooseModel (item, e) {
      this.currentModel = item
      this.showColor = true
    },
    chooseColor (item) {
      this.currentColor = item
      this.submit()
    },
    hiddenModel () {
      if (!this.showModel) return
      this.showModel = false
    },
    hiddenColor () {
      if (!this.showColor) return
      this.showColor = false
    },
    submit () {
      this.$emit('change', {
        currentBrand: this.currentBrand,
        currentModel: this.currentModel,
        currentColor: this.currentColor,
        name: `${this.currentBrand.carIdent} ${this.currentModel.carName} ${
          this.currentColor.name
        }`
      })
    },
    chooseIndex (item) {
      this.currentIndex = item
    }
  },
  mounted () {
    this.init()
  }
}
</script>
